import { createContext } from 'react';
import type { Dealer } from '../interfaces/header-components.interfaces';
import type { OidcUser } from '../types/oidc-user-info';

interface OidcUserContext {
  readonly oidcUser: OidcUser | null;
  loading: boolean;
  error: string | null;
}

interface DealerContextInterface {
  readonly renderDealerContext: boolean;
  readonly dealerData?: Dealer;
  readonly removeDealer: (label?: string) => void;
}

export const OidcUserContext = createContext<OidcUserContext>({} as OidcUserContext);

export const DealerContext = createContext<DealerContextInterface>({} as DealerContextInterface);
